import { render, staticRenderFns } from "./subAppeal.vue?vue&type=template&id=1c8a426a&scoped=true"
import script from "./subAppeal.vue?vue&type=script&lang=js"
export * from "./subAppeal.vue?vue&type=script&lang=js"
import style0 from "./subAppeal.vue?vue&type=style&index=0&id=1c8a426a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a426a",
  null
  
)

export default component.exports